import Navbar from './navbar'
import Section from './section'
import s from './styles.module.css'
import cn from 'classnames'
import { renderContentItems } from 'utilities/contentful'
import Link from 'next/link'
import ExpertCard from './experts'
import Footer from './footer'
import { useState } from 'react'
import { createSlug } from 'utilities/blog'
import PostsByCategories from './section/posts-by-category'
import PostGrid from './section/post-grid'
import FitnessGoalCategories from './section/fitness-goal-categories'

const Homepage = ({
  limit,
  setLimit,
  title,
  categories,
  latestPosts,
  featuredPosts,
  postsByCategory,
  experts,
  editorialIntegrity,
}) => {
  return (
    <>
      <PostGrid
        title={'Latest'}
        posts={latestPosts}
        limit={limit}
        setLimit={setLimit}
      />
      <FitnessGoalCategories categories={categories} />
      <PostGrid
        title={title}
        posts={featuredPosts}
        limit={limit}
        setLimit={setLimit}
      />
      <PostsByCategories postsByCategory={postsByCategory} />
      <div>
        <Section title="Meet the Experts" className={s.sectionWithPadding}>
          <div className={s.expertsSection}>
            {editorialIntegrity && (
              <div>
                <h2 className={s.eiTitle}>Editorial Integrity</h2>
                <div className={s.editorialIntegrity}>
                  {renderContentItems(
                    editorialIntegrity.fields.content.content
                  )}
                </div>
                {/* <Link href={'/blog/experts'} className={s.link}>
                      <span>View All</span> <RightIcon />
                    </Link> */}
              </div>
            )}
            {experts.map(expert => (
              <ExpertCard key={`expert-${expert.sys.id}`} expert={expert} />
            ))}
          </div>
        </Section>
      </div>
    </>
  )
}

const CategoryPage = ({
  limit,
  setLimit,
  title,
  featuredPosts,
  categories,
  otherCategories,
  postsByCategory,
}) => {
  return (
    <>
      <PostGrid
        title={title}
        posts={featuredPosts}
        limit={limit}
        setLimit={setLimit}
      />
      <FitnessGoalCategories categories={categories} />
      <PostsByCategories postsByCategory={postsByCategory} />
      <div>
        <Section
          title="Other Topics"
          titleLocation="center"
          className={cn(s.sectionWithPadding, s.sectionGray50)}>
          <div className={s.categoryCards}>
            {otherCategories.map((category, i) => {
              const slug = createSlug(category.fields)
              return (
                <Link
                  key={`category-${i}`}
                  href={`${slug}`}
                  className={cn(s.otherCategory)}>
                  <span className={s.categoryName}>{category.fields.name}</span>
                </Link>
              )
            })}
          </div>
        </Section>
      </div>
    </>
  )
}

export default function BlogPosts({
  title,
  topNav,
  template,
  categories,
  experts,
  latestPosts,
  featuredPosts,
  postsByCategory,
  editorialIntegrity,
  footer,
  isHomepage,
  otherCategories,
}) {
  const [limit, setLimit] = useState(4)

  return (
    <div>
      <Navbar template={topNav} />
      <main className={s.main}>
        <header className={s.header}>
          <div className={s.overline}>{template.fields?.overline || ''}</div>
          <h1 className={s.headline}>{template.fields?.heading || ''}</h1>
          <div className={s.subline}>
            {template.fields?.supportingText || ''}
          </div>
        </header>
        {isHomepage ? (
          <Homepage
            limit={limit}
            setLimit={setLimit}
            title={title}
            categories={categories}
            latestPosts={latestPosts}
            featuredPosts={featuredPosts}
            postsByCategory={postsByCategory}
            experts={experts}
            editorialIntegrity={editorialIntegrity}
          />
        ) : (
          <CategoryPage
            limit={limit}
            setLimit={setLimit}
            title={title}
            featuredPosts={featuredPosts}
            postsByCategory={postsByCategory}
            categories={categories}
            otherCategories={otherCategories}
          />
        )}
      </main>
      <Footer items={footer} />
    </div>
  )
}
